import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import Options from '../../general/options';
import Unit from '../../general/unit';
import Criterials from '../../general/criterials';

class FormBagsGroup extends Component{
	constructor(props){
		super(props);
		this.getOption = this.getOption.bind(this);

		this.state = {
			option : ""
		}
	}

	componentDidMount(){
		this.props.onRef(this);

		this.setState({
			option: "Unit"
		})
	}

	
	getOption(option){
		this.setState({
			option:option
		});
	}

	render(){
		const {t} = this.props;
		return (
			<div className="row col-xs-12 form-group">
				<Options {...this.props} sendData={this.getOption} onRef={ref => (this.options = ref)} />

				<hr style={{width:"97%"}}/>
				
				{this.state.option === 'Unit' ?
					<Unit {...this.props} onRef={ref => (this.unit = ref)} />
				: 	<Criterials {...this.props} onRef={ref => (this.criterials = ref)} />
				}

				<hr style={{width:"97%"}}/>

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-1" style={{textAlign:"right"}}>
						<span>Fecha</span>
					</div>
					<div className="col-xs-12 col-sm-2">
						<input className="form-control" type="date" />
					</div>

					<div className="col-xs-12 col-sm-1" style={{textAlign:"right"}}>
						<span>Hora</span>
					</div>
					<div className="col-xs-12 col-sm-2">
						<input className="form-control hour-input" type="time" />
					</div>
				</div>


				<div className="col-xs-12 col-sm-10 col-sm-offset-1 form-group">
					<div className="col-xs-12 col-sm-4">
						<Table responsive hover>
							<thead>
								<tr>
									<th>Donación</th>
									<th>Fecha</th>
								</tr>
							</thead>
						</Table>
					</div>
					
					<div className="col-xs-12 col-sm-8">
						<Table responsive hover>
							<thead>
								<tr>
									<th>GRUPO</th>
									<th>RH</th>
									<th>DU</th>
								</tr>
							</thead>
						</Table>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations')(FormBagsGroup);